import { useState, useEffect } from "react";
import { phasePct, wsProgress } from "./HomeView";
import Workstream from "../components/Workstream";

export default function Phase1View({ state, setState, isAdmin, goHome, refresh, setSavedAt, pendingFocus, clearPendingFocus }) {
  const [focusWsN, setFocusWsN] = useState(null);

  useEffect(() => {
    if (!pendingFocus) return;
    const focus = pendingFocus.focus || {};
    if ((focus.kind === "workstream" || focus.kind === "comment") && focus.n != null) {
      setFocusWsN(focus.n);
      setTimeout(() => {
        const el = document.querySelector(`[data-testid="ws-${focus.n}"]`);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          el.classList.add("home-block-flash");
          setTimeout(() => el.classList.remove("home-block-flash"), 1600);
        }
      }, 120);
    }
    clearPendingFocus?.();
  }, [pendingFocus]);

  const w = state.workstreams;
  const done = w.filter((x) => wsProgress(x) >= 100).length;
  const pend = w.filter((x) => wsProgress(x) <= 0).length;
  const prog = w.length - done - pend;
  const pct = phasePct(w);

  const onChange = (newState) => {
    setState(newState);
    setSavedAt("Saved · " + new Date().toLocaleTimeString());
  };

  return (
    <div className="view" data-testid="phase1-view">
      <div className="crumb">
        <a onClick={goHome} data-testid="back-to-phases">← All phases</a>
        {" / "}
        Phase 1 · Exploration (complete)
      </div>
      <div className="summary-grid">
        <div className="stat big">
          <div className="stat-label">Phase 1 Progress · Exploration</div>
          <div className="stat-num" data-testid="phase-pct">
            <span>{pct}</span>%
          </div>
          <div className="bar-track">
            <div className="bar-fill" style={{ width: `${pct}%` }} />
          </div>
        </div>
        <div className="stat">
          <div className="stat-label">Done</div>
          <div className="stat-num" data-testid="count-done">
            {done}<span className="of">/14</span>
          </div>
        </div>
        <div className="stat">
          <div className="stat-label">In Progress</div>
          <div className="stat-num" data-testid="count-progress">
            {prog}<span className="of">/14</span>
          </div>
        </div>
        <div className="stat">
          <div className="stat-label">Not Started</div>
          <div className="stat-num" data-testid="count-pending">
            {pend}<span className="of">/14</span>
          </div>
        </div>
      </div>

      <div data-testid="panel-workstreams">
        <div className="sec-head">14 Exploration Workstreams</div>
        <div className="sec-desc">
          Full Phase 1 scope. Click a row to expand, set status, edit the note,
          or attach the completed deliverable link.
        </div>
        <div id="wsList">
          {state.workstreams.map((ws, i) => (
            <Workstream
              key={ws.n}
              ws={ws}
              idx={i}
              isAdmin={isAdmin}
              onChange={onChange}
              state={state}
              refresh={refresh}
              forceOpen={focusWsN === ws.n}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
